import find from 'lodash/find'
import moment from 'moment'

function transformToCalendarHeaderAndDays(availableDays) {
    let weekDayNames = []
    for (let i = 1; i <= 7; i++) {
        weekDayNames.push(moment().day(i).format('ddd').toUpperCase())
    }

    const calendarDays = []
    const startOfWeek = moment(availableDays[0]).startOf('isoWeek')
    const firstDay = moment(availableDays[0])
    const lastDay = moment(availableDays.slice(-1)[0])
    var day
    var dayIdx = 0

    do {
        day = startOfWeek.clone().add(dayIdx, 'days')
        dayIdx++

        const availability = day.isBefore(firstDay)
            ? 'passed'
            : find(availableDays, (a) => day.isSame(a, 'day'))
            ? 'available'
            : 'unavailable'

        calendarDays.push({ day, availability })
    } while (day.isBefore(lastDay))

    return { weekDayNames, calendarDays }
}

function getWeekDays() {
    let weekDayNames = []
    for (let i = 1; i <= 7; i++) {
        weekDayNames.push(moment().day(i).format('ddd').toUpperCase())
    }

    return weekDayNames
}

function getOffset(date) {
    return Math.abs(moment().startOf('isoWeek').diff(date, 'days'))
}

function getDefaultDeliveryDates() {
    const dates = []
    const start = moment()
    for (let i = 1; i <= process.env.DISTRIBUTION_LIMIT_DAYS; i++) {
        dates.push(start.clone().add(i, 'days').format('YYYY-MM-DD'))
    }
    return dates
}

export { transformToCalendarHeaderAndDays, getWeekDays, getOffset, getDefaultDeliveryDates }
